import { Component, Input } from '@angular/core';
import { FiltrosMapeamentoForm } from '../../../types/smartinteg';
import { OPERADORES_DESCARTE, novaRegraDescarte, novoDePara, operadorDescarteSemValor } from './mapeamento-filtros.util';

/**
 * Editor de ComandoMapeamento.filtros: de-para (troca de valor por lookup) e regras de descarte (registro inteiro
 * é ignorado). Edita o modelo recebido no lugar; quem salva usa montarFiltros/validarFiltros do util.
 */
@Component({
  selector: 'app-mapeamento-filtros',
  templateUrl: './mapeamento-filtros.component.html',
  styleUrls: ['./mapeamento-filtros.component.css']
})
export class MapeamentoFiltrosComponent {

  @Input() model!: FiltrosMapeamentoForm;
  @Input() secaoVisivel: 'todas' | 'geral' | 'campos' | 'conversoes' | 'descarte' = 'todas';

  readonly operadores = OPERADORES_DESCARTE;
  operadorSemValor = operadorDescarteSemValor;
  private deParasAbertos = new Set<number>();
  private regrasAbertas = new Set<number>();

  quantidadePares(pares: Record<string, unknown>): number { return Object.keys(pares ?? {}).length; }
  deParaAberto(i: number): boolean { return this.deParasAbertos.has(i); }
  regraAberta(i: number): boolean { return this.regrasAbertas.has(i); }
  alternarDePara(i: number): void { this.alternar(this.deParasAbertos, i); }
  alternarRegra(i: number): void { this.alternar(this.regrasAbertas, i); }

  adicionarDePara(): void {
    this.model.deParas.push(novoDePara());
    this.deParasAbertos.add(this.model.deParas.length - 1);
  }
  removerDePara(i: number): void {
    this.model.deParas.splice(i, 1);
    this.deParasAbertos = this.reindexar(this.deParasAbertos, i);
  }

  adicionarRegraDescarte(): void {
    const proximaPrioridade = this.model.regrasDescarte.length > 0 ? Math.max(...this.model.regrasDescarte.map(r => r.prioridade)) + 1 : 1;
    this.model.regrasDescarte.push(novaRegraDescarte(proximaPrioridade));
    this.regrasAbertas.add(this.model.regrasDescarte.length - 1);
  }
  removerRegraDescarte(i: number): void {
    this.model.regrasDescarte.splice(i, 1);
    this.regrasAbertas = this.reindexar(this.regrasAbertas, i);
  }

  private alternar(abertos: Set<number>, i: number): void {
    if (abertos.has(i)) abertos.delete(i);
    else abertos.add(i);
  }

  private reindexar(abertos: Set<number>, removido: number): Set<number> {
    return new Set([...abertos].filter(i => i !== removido).map(i => i > removido ? i - 1 : i));
  }
}
